import { Theme, Typography } from '@mui/material';

import { Icon } from '@/components/Icon';

import { useTranslate } from '@/hooks/useTranslate';

import { ConfirmChoiceAlerContainerStyled } from './ConfirmChoiceAlert.styled';

const ConfirmChoiceAlert = () => {
  const { t } = useTranslate();
  return (
    <ConfirmChoiceAlerContainerStyled direction="row" alignItems="flex-start">
      <Icon
        name="warning"
        color={theme => theme.palette.semantic.warning[500]}
      />
      <Typography
        variant="bodyB2Medium"
        sx={{ color: (theme: Theme) => theme.palette.semantic.warning[600] }}
      >
        {t('questionDrawer.minorQuestionConsentSign.dialog.warning')}
      </Typography>
    </ConfirmChoiceAlerContainerStyled>
  );
};

export default ConfirmChoiceAlert;
